import { Flex, Skeleton } from "@chakra-ui/react";
import React from "react";

const BookingFormSkeleton = () => {
  return (
    <Flex
      mt={"35px"}
      direction={{
        base: "column",
        lg: "row",
      }}
      gap={"35px"}
    >
      <Skeleton
        sx={{ flex: 1, height: "27rem", borderRadius: "20px" }}
      ></Skeleton>
      <Skeleton
        pl={"20px"}
        h={"27rem"}
        maxWidth={{
          base: "100%",
          lg: "35%",
        }}
        flex={{
          base: "100%",
          lg: "35%",
        }}
        marginTop={{
          base: "50px",
          lg: "0px",
        }}
        borderRadius={"20px"}
      ></Skeleton>
    </Flex>
  );
};

export default BookingFormSkeleton;
